// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_array from "rescript/lib/es6/caml_array.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Blog$BenfaerberBlog from "../lib/Blog.bs.js";
import * as Project$BenfaerberBlog from "../lib/Project.bs.js";

function s(prim) {
  return prim;
}

function LargeProjectItem(props) {
  var project = props.project;
  var links = project.links;
  var stack = project.stack;
  var slug = project.slug;
  var title = project.title;
  var lang = Project$BenfaerberBlog.getLanguageInfo(project.language);
  var img = function () {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx("img", {
                        alt: title,
                        src: "/projects/images/" + slug + ".webp"
                      }),
                  JsxRuntime.jsx("img", {
                        className: "language-badge",
                        alt: "Badge " + lang.name,
                        src: "images/languages/" + lang.image
                      })
                ]
              });
  };
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("figure", {
                                  children: links !== undefined && links.length !== 0 ? JsxRuntime.jsx("a", {
                                          children: img(),
                                          className: "monospace black-link",
                                          href: Caml_array.get(links, 0).url,
                                          rel: "noreferrer",
                                          target: "_blank"
                                        }) : img(),
                                  className: "image is-4by3"
                                }),
                            className: "card-image project-image"
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("h4", {
                                          children: links !== undefined && links.length !== 0 ? JsxRuntime.jsx("a", {
                                                  children: title,
                                                  className: "monospace black-link",
                                                  href: Caml_array.get(links, 0).url,
                                                  rel: "noreferrer",
                                                  target: "_blank"
                                                }) : title
                                        }),
                                    project.description,
                                    JsxRuntime.jsx("br", {}),
                                    JsxRuntime.jsx("span", {
                                          className: "px-2"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  children: links !== undefined && links.length !== 0 ? Belt_Array.map(links, (function (link) {
                                                            var url = link.url;
                                                            return JsxRuntime.jsx("div", {
                                                                        children: JsxRuntime.jsx("a", {
                                                                              children: link.name,
                                                                              className: "monospace",
                                                                              href: url,
                                                                              rel: "noreferrer",
                                                                              target: "_blank"
                                                                            }, "link-" + url)
                                                                      }, "link-" + url);
                                                          })) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                                  className: "column"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    stack !== undefined ? Belt_Array.map(stack, (function (item) {
                                                              return JsxRuntime.jsx("span", {
                                                                          children: item,
                                                                          className: "category-tag"
                                                                        }, "stack-" + item);
                                                            })) : "",
                                                    JsxRuntime.jsx("div", {
                                                          children: Blog$BenfaerberBlog.getPrettyDatePartial(project.date),
                                                          className: "pt-3 monospace"
                                                        })
                                                  ],
                                                  className: "column has-text-right category-tags"
                                                })
                                          ],
                                          className: "columns"
                                        })
                                  ],
                                  className: "content"
                                }),
                            className: "card-content"
                          })
                    ],
                    className: "card"
                  }),
              className: "project-item",
              id: "project-" + slug
            });
}

var make = LargeProjectItem;

export {
  s ,
  make ,
}
/* react/jsx-runtime Not a pure module */
